module.exports = __webpack_public_path__ + "coin_CNY.svg?676403bc53355b612f37bf5986f32b9d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/coin_CNY.svg
// module id = 1139
// module chunks = 2